import React from "react";

import { ICardProps } from "./types";
import { IInstallmentItem } from "models";
import usePayment from "hooks/usePayment";
import { Input, Select } from "components";
import { isCnpjMask } from "utils/mask";

import * as S from "./styles";
import { useFormContext, useWatch } from "react-hook-form";
import { checkFlag } from "utils";

export const CreditCard: React.FC<ICardProps> = ({ enable }) => {
  const { installmentsToUse, setPaymentCard, paymentCard } = usePayment();

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const cardNumber = useWatch({ name: "number", control });

  if (!installmentsToUse.length || installmentsToUse[0] === undefined) {
    return null;
  }

  return (
    <S.Container
      enable={enable}
      style={{ borderRadius: "0px 0px 8px 8px", overflow: "hidden" }}
    >
      <S.Row>
        <S.WrapperRight active={enable}>
          <S.WrapperHeader>
            <S.Title>Dados do cartão </S.Title>
          </S.WrapperHeader>

          <S.RowInputs>
            <S.WrapperInput>
              <Select
                onChange={(e: any) => {
                  const installment = installmentsToUse.find(
                    ({ id_charge_option }) =>
                      id_charge_option === e.target.value
                  ) as IInstallmentItem;

                  setPaymentCard({
                    ...paymentCard,
                    id_charge_option: e.target.value,
                    installment,
                  });
                }}
                name="installments"
                control={control}
                error={errors?.installments?.message as string}
              >
                {installmentsToUse.map((installment) => {
                  return (
                    <S.Option
                      key={installment.installment_number}
                      value={installment.installment_number}
                    >
                      {installment.description}
                    </S.Option>
                  );
                })}
              </Select>
            </S.WrapperInput>
          </S.RowInputs>

          <S.WrapperInputCard>
            <div style={{
              position: "absolute",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              left: "8px",
              paddingRight: "8px",
              zIndex: 1,
            }}>
              <img
                style={{
                  width: "42px",
                  height: "32px",
                  border: "1.5px solid #F2F4F7",
                  borderRadius: "4px",
                  marginRight: "8px",
                  padding: "3px",
                }}
                src={checkFlag({ cardNumber })}
              />
              <div
                style={{ borderRight: "1px solid #D7DFE9", height: "20px" }}
              ></div>
            </div>
            <Input
              data-testid="card-number-input"
              type="text"
              type_input="normal"
              placeholder="Número do cartão"
              style={{ paddingLeft: "64px" }}
              onChange={(e: any) =>
                setPaymentCard({
                  ...paymentCard,
                  number: e.target.value,
                })
              }
              name="number"
              control={control}
              error={errors?.number?.message as string}
              mask={"9999 9999 9999 9999"}
            />
          </S.WrapperInputCard>

          <S.RowInputs>
            <S.WrapperInput>
              <Input
                data-testid="card-expiry-input"
                type="text"
                type_input="normal"
                placeholder="Validade"
                onChange={(e: any) =>
                  setPaymentCard({
                    ...paymentCard,
                    due_date: e.target.value,
                  })
                }
                name={"due_date"}
                mask={"99/99"}
                control={control}
                error={errors?.due_date?.message as string}
              />
            </S.WrapperInput>
            <S.MarginInputs />
            <S.WrapperInput>
              <Input
                data-testid="card-cvv-input"
                type="text"
                type_input="normal"
                placeholder="CVV / CVC"
                onChange={(e: any) =>
                  setPaymentCard({
                    ...paymentCard,
                    cvv: e.target.value,
                  })
                }
                alwaysShowMask={false}
                maskChar=""
                mask="9999"
                name={"cvv"}
                control={control}
                error={errors?.cvv?.message as string}
                maxLength={4}
              />
            </S.WrapperInput>
          </S.RowInputs>

          <S.WrapperInput>
            <Input
              data-testid="card-holder-name-input"
              type="text"
              uppercase={true}
              type_input="normal"
              placeholder="Titular do cartão"
              onChange={(e: any) =>
                setPaymentCard({
                  ...paymentCard,
                  name: e.target.value.toUpperCase(),
                })
              }
              name="name"
              control={control}
              error={errors?.name?.message as string}
            />
          </S.WrapperInput>

          <S.WrapperInput>
            <Input
              data-testid="card-document-input"
              type="text"
              type_input="normal"
              placeholder="CPF / CNPJ do titular"
              onChange={(e: any) =>
                setPaymentCard({
                  ...paymentCard,
                  cpfCnpj: e.target.value,
                })
              }
              mask={isCnpjMask(paymentCard.cpfCnpj)}
              maskChar=""
              name="cpfCnpj"
              control={control}
              error={errors?.cpfCnpj?.message as string}
            />
          </S.WrapperInput>
        </S.WrapperRight>
      </S.Row>
    </S.Container>
  );
};
